/**
 * Display and parse "min – max" stock bands (e.g. 5 - 2000) for bulk import UI.
 */

export function formatStockRange(min: number, max: number): string {
  const lo = Math.max(0, Math.floor(Number(min) || 0));
  const hi = Math.max(lo, Math.floor(Number(max) || 0));
  return `${lo} - ${hi}`;
}

/** Accepts hyphen, en/em dash, colon, or "to" between two integers. */
export function parseStockRange(input: string): { min: number; max: number } | null {
  const s = String(input || '')
    .trim()
    .replace(/[–—]/g, '-');
  if (!s) return null;
  const parts = s.split(/\s*-\s*|\s*:\s*|\s+to\s+/i);
  if (parts.length !== 2) return null;
  const a = Math.floor(Number(parts[0].trim()));
  const b = Math.floor(Number(parts[1].trim()));
  if (!Number.isFinite(a) || !Number.isFinite(b)) return null;
  let lo = Math.max(0, a);
  let hi = Math.max(0, b);
  if (lo > hi) [lo, hi] = [hi, lo];
  hi = Math.max(lo, hi);
  return { min: lo, max: hi };
}
